import { type FormatOptions, format as f } from "date-fns";

export default (
  date: string | number | Date | undefined,
  formatStr: string,
  options?: FormatOptions | undefined,
) => {
  if (!date) {
    return "";
  } else {
    return f(
      typeof date === "string"
        ? date.replaceAll(/\//g, "-").replaceAll(/\s/g, "T")
        : date,
      formatStr,
      options,
    );
  }
};
